import {
  getFAQService,
  getHoraImagen,
  getImagenPerfil,
  getUser,
  postChangePassword,
  postImagenPerfil,
} from "services/authServices/authServices";
import { Login } from "interfaces/authInterface";
import { BodyChangePassword } from "interfaces/auth/authInterfaces";
import { postLogin } from "../services";
import {
  clearErrorMessage,
  onLogin,
  onLogout,
  onChecking,
  setIsLoading,
  setMessageLoading,
  setOpenSnackBar,
  onChangeOpenModalPassword,
  onAddImageProfile,
  onAddImagenHora,
  onGetLstFAQ,
  onSetSeccionSelect,
  onSetNormas,
} from "../store";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import { findUserDevice } from "helpers/findUserDevice";
import { ipifyService } from "services/ipifyService/ipifyService";
import { useUiStore } from "./useUiStore";
import Swal from "sweetalert2";

export const useAuthStore = () => {
  const { status, user, errorMessage, showModalChangePassword, urlPhoto, imagenHora, seccionSelect, lstFAQ, isNorma} =
    useAppSelector((state) => state.auth);
  const { optionsSnackBar, handleModalTour, handleAyudaTour } = useUiStore();

  const dispatch = useAppDispatch();

  const startLogin = (body: Login) => {
    startChecking();
    ipifyService()
      .then(({ data }) => {
        const device = findUserDevice();
        let newBody = {
          ...body,
          ipPublica: data,
          cveTipoDispositivo: device,
        };
        startPostLogin(newBody);
      })
      .catch((err) => {
        console.log(err);
        startPostLogin(body);
      });
  };

  const startPostLogin = (body: Login) => {
    postLogin(body)
      .then(({ data }) => {
        localStorage.setItem("refresh_token", data.data.refresh_token);
        localStorage.setItem("token", data.data.access_token);
        localStorage.setItem("user", body.user);
        startGetUser();
        handleAyudaTour(false);
        if (process.env.REACT_APP_FECHA_MODAL_RECORRIDO && (new Date(process.env.REACT_APP_FECHA_MODAL_RECORRIDO) > new Date())) {
          handleModalTour(true);
        } else {
          handleModalTour(false);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(onLogout("Credenciales incorrectas"));
        handleModalTour(false);
        handleAyudaTour(false);
        setTimeout(() => {
          dispatch(clearErrorMessage());
        }, 3000);
      });
  };

  const startGetUser = () => {
    getUser()
      .then(({ data }) => {
        dispatch(onLogin(data.data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(clearErrorMessage());
      });
  };

  const startGetHoraImagen = () => {
    getHoraImagen()
      .then(({ data }) => {
        const hora = data?.data?.hora;
        if (!hora) return;
        const [hh, mm, ss] = hora.split(":").map(Number);
        const horaNum = hh * 10000 + mm * 100 + ss;

        if (horaNum >= 210000 || horaNum <= 35959) {
          dispatch(onAddImagenHora("noche"));
        } else if (horaNum >= 40000 && horaNum <= 95959) {
          dispatch(onAddImagenHora("amanecer"));
        } else if (horaNum >= 100000 && horaNum <= 155959) {
          dispatch(onAddImagenHora("dia"));
        } else if (horaNum >= 160000 && horaNum <= 205959) {
          dispatch(onAddImagenHora("tarde"));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(onAddImagenHora("dia"));
      });
  };
  const startGetFAQ = () => {
    getFAQService()
      .then(({ data }) => {
      if(data?.data){
        dispatch(onGetLstFAQ(data?.data));
      }
      })
      .catch((err) => {
        console.log(err);
        dispatch(onGetLstFAQ([]));
        Swal.fire({
          title: "Advertencia",
          text:
            err.response?.data?.data ||
            "Hubo un problema al obtener las preguntas frecuentes",
          icon: "warning",
        });
      });
  };
  const startChangePassword = (body: BodyChangePassword) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Cambiando Contraseña"));
    postChangePassword(body)
      .then(({ data }) => {
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(true));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "Contraseña actualizada correctamente",
          })
        );
        changeOpenModalPassword(false);
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: err.response.data.data,
            optionsSnackBar: {
              ...optionsSnackBar,
              type: "error",
            },
          })
        );
        changeOpenModalPassword(false);
        Swal.fire({
          title: "Error",
          text: err?.response?.data?.error_msg || "Hubo un error en el cambio de contraseña",
          icon: "warning",
        });
      });
  };

  const startGetImagenPerfil = () => {
    getImagenPerfil()
      .then(({ data }) => {
        dispatch(onAddImageProfile(data.data.url));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startChangeImagenPerfil = <T>(body: T) => {
    dispatch(setMessageLoading("Actualizando foto de perfil"));
    dispatch(setIsLoading(true));
    postImagenPerfil(body)
      .then(({ data }) => {
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        startGetImagenPerfil();
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "Foto de perfil actualizada correctamente",
          })
        );
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "No se ha podido actualizar la foto de perfil",
            optionsSnackBar: optionsSnackBar,
          })
        );
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const changeSeccionSelect = (seccion: number) =>
    dispatch(onSetSeccionSelect(seccion));

  const changeOpenModalPassword = (status: boolean) =>
    dispatch(onChangeOpenModalPassword(status));

  const changeIsNorma = (bandera: boolean) =>
    dispatch(onSetNormas(bandera));

  const startChecking = () => dispatch(onChecking());
  const startLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("openModalSession");
    localStorage.removeItem("refresh_token");
    dispatch(onLogout("Sesión cerrada"));
  };

  return {
    /**Propiedades **/
    urlPhoto,
    status,
    user,
    errorMessage,
    showModalChangePassword,
    imagenHora,
    seccionSelect,
    lstFAQ, 
    isNorma,
    /** Métodos **/
    startLogin,
    startGetUser,
    startChecking,
    startLogout,
    startChangePassword,
    changeOpenModalPassword,
    startGetImagenPerfil,
    startChangeImagenPerfil,
    startGetHoraImagen,
    changeSeccionSelect,
    startGetFAQ,
    changeIsNorma,
  };
};
